import { useState } from 'react';

const useLite = (location: any, history: any, versionStr: string) => {
    const [activeKey, setActiveKey] = useState<string>(() => {
        const path = location.pathname;
        const hash = location.hash;
        if (path === '/lite') {
            if (hash === '#demo') {
                return 'demo';
            }
            return 'paddleLite';
        } else if (path.includes('/introduction/faq.html')) {
            return 'faq';
        } else if (path.includes('api_reference')) {
            return 'apiDoc';
        } else {
            return 'guide';
        }
    });

    const initTabsParams = (currentKey: string) => {
        const version = versionStr ? versionStr : 'v2.12';
        setActiveKey(currentKey);
        if (currentKey === 'paddleLite') {
            history.push('/lite');
        } else if (currentKey === 'demo') {
            history.push('/lite#demo');
        } else if (currentKey === 'apiDoc') {
            history.push(`/lite/${version}/api_reference/cxx_api_doc.html`);
        } else if (currentKey === 'faq') {
            history.push(`/lite/${version}/quick_start/faq.html`);
        } else if (currentKey === 'guide') {
            history.push(`/lite/${version}/guide/introduction.html`);
        }
    };

    return {
        activeKey,
        initTabsParams
    };
};

export default useLite;
